import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CLERK_PUBLISHABLE_KEY } from './shared/config';
import { AuthGate } from './app/providers/AuthGate';
import { ThemeRoot } from './app/providers/ThemeRoot';
import { App } from './app/App';
import './shared/styles/tokens.css';

// Data layer: React Query hooks fall back to typed fixtures in dev/MSW mode (see shared/api/data.ts),
// so the shell previews without live auth/backend. No service-worker file needed for W0.
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 } },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeRoot>
        <AuthGate clerkKey={CLERK_PUBLISHABLE_KEY}>
          <App />
        </AuthGate>
      </ThemeRoot>
    </QueryClientProvider>
  </React.StrictMode>,
);
